const LOCAL_LAUNCH = {
  ZTASK: { baseUrl: 'http://localhost:3002', path: '/dashboard' },
  ZORDER: { baseUrl: 'http://localhost:3002', path: '/order-dashboard' },
  ZHR: { baseUrl: 'http://localhost:3100', path: '/' },
  ZASSET: { baseUrl: 'http://localhost:3002', path: '/assets' },
  ZCUSTOMER: { baseUrl: 'http://localhost:3002', path: '/customers' },
  ZCOMPLIANCE: { baseUrl: 'http://localhost:3002', path: '/compliance' },
  ZMAINTENANCE: { baseUrl: 'http://localhost:3200', path: '/' },
  ZINVENTORY: { baseUrl: 'http://localhost:3210', path: '/' },
};

/**
 * Resolve launcher target for an app tile.
 * Prefer baked REACT_APP_* env URL (staging/prod). Fall back to local defaults
 * only when no env URL is set (local CRA without .env override).
 */
export function resolveAppLaunch(appName, envUrl) {
  const key = (appName || '').trim().toUpperCase().replace(/\s+/g, '');
  const local = LOCAL_LAUNCH[key];
  const trimmed = (envUrl || '').replace(/\/$/, '');

  if (trimmed) {
    return { baseUrl: trimmed, path: local?.path || '/' };
  }
  if (local) {
    return local;
  }
  return { baseUrl: '', path: '/' };
}
